import { render, staticRenderFns } from "./ListReturnFromCustomer.vue?vue&type=template&id=5c321f06&scoped=true&"
import script from "./ListReturnFromCustomer.vue?vue&type=script&lang=ts&"
export * from "./ListReturnFromCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c321f06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c321f06')) {
      api.createRecord('5c321f06', component.options)
    } else {
      api.reload('5c321f06', component.options)
    }
    module.hot.accept("./ListReturnFromCustomer.vue?vue&type=template&id=5c321f06&scoped=true&", function () {
      api.rerender('5c321f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/return-form-customer/ListReturnFromCustomer.vue"
export default component.exports